import type { PublicEvent, SubmissionAttemptStatus } from '../../shared/types';
import type { RegState } from './state';
import { initializePdfProgress } from './pdfState';
/**
 * Save this state synchronously before sending anything. Every new attempt gets a fresh key: a
 * staged attempt keeps its key until it completes or is released, and a key left by an earlier
 * version of the page can only be checked, never resumed.
 */
export function beginParticipantSubmission(event: PublicEvent, state: RegState): RegState {
  const progress = state.pdfProgress ?? initializePdfProgress(event);
  if (progress.submissionAttemptNeedsReconciliation) throw new Error('reconciliation_required');
  return { ...state, pdfProgress: { ...progress, submissionAttemptId: crypto.randomUUID(), submissionAttemptRevisionId: event.publishedRevisionId, submissionAttemptNeedsReconciliation: true } };
}
/** Only explicit server status can unlock an uncertain attempt. No automatic resubmission. */
export function applySubmissionStatus(event: PublicEvent, state: RegState, status: SubmissionAttemptStatus): RegState {
  if (!state.pdfProgress?.submissionAttemptId || !['retryable','not_found'].includes(status.state)) return state;
  const { submissionAttemptNeedsReconciliation: _pending, ...progress } = state.pdfProgress;
  if (progress.submissionAttemptRevisionId !== event.publishedRevisionId) {
    delete progress.submissionAttemptId; delete progress.submissionAttemptRevisionId; delete progress.submission;
  }
  return { ...state, pdfProgress: progress };
}
